import { Box, Text } from '@acast/decibel';
import T from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background-color: #f9fafb;
  border: 1px solid #e3e4e7;
`;

const Header = styled(Box).attrs({
  py: 3,
  px: 6,
  justifyContent: 'space-between',
  alignItems: 'center',
})`
  border-bottom: 1px solid #e3e4e7;
`;

const createTestId = (title, element) => {
  switch (title) {
    case 'Spotify':
      return `SpotifyDistribution__${element}`;
    case 'Apple Podcasts':
      return `AppleDistribution__${element}`;
    default:
      return null;
  }
};

const Distribution = ({ title, logo, logoAlt, button, children }) => (
  <Container data-test-id={createTestId(title, 'root')}>
    <Header>
      <Box alignItems="center" gap={4}>
        <img src={logo} alt={logoAlt} />
        <Text variant="body2" mb={0}>
          {title}
        </Text>
      </Box>
      {button}
    </Header>

    <Box p={6} flexDirection="column" data-test-id={createTestId(title, 'description')}>
      {children}
    </Box>
  </Container>
);

Distribution.propTypes = {
  title: T.string.isRequired,
  logo: T.string.isRequired,
  logoAlt: T.string.isRequired,
  button: T.node.isRequired,
  children: T.node.isRequired,
};

export default Distribution;
